var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-x.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.192 6.84399L11.949 11.086L7.70697 6.84399L6.29297 8.25799L10.535 12.5L6.29297 16.742L7.70697 18.156L11.949 13.914L16.192 18.156L17.606 16.742L13.364 12.5L17.606 8.25799L16.192 6.84399Z",
    fill: "#00B45E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxX);
export default __webpack_public_path__ + "static/media/bx-x.5ab1b75ed151eab65d60f09e9ec8c844.svg";
export { ForwardRef as ReactComponent };